import { cB as o } from "./ghl-ui.es384.js";
const s = o("popselect-menu", `
 box-shadow: var(--n-menu-box-shadow);
`);
export {
  s as default
};
